"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Time = void 0;
var time_1 = require("../data/time");
var dsvg_1 = require("../dsvg");
var commondata_1 = require("./commondata");
var draw_1 = require("./draw");
var default_options = {
    fontsize: 12,
    interaction: true,
    refreshTime: 60000,
    middle_day_line: false,
    outborder: true
};
/**
 * 分时图
 */
var Time = /** @class */ (function () {
    function Time(options) {
        this.options = Object.assign({}, default_options, options);
        this.destory();
    }
    Time.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, time_1.timeData)({
                            ut: this.options.ut,
                            quotecode: this.options.quotecode,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Time.prototype.refresh = function () {
        var _this = this;
        this.timer && clearInterval(this.timer);
        if (this.options.refreshTime) {
            this.timer = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.draw("update");
                    return [2 /*return*/];
                });
            }); }, this.options.refreshTime);
        }
    };
    /** 获取数据并绘图 */
    Time.prototype.draw = function (type) {
        if (type === void 0) { type = "init"; }
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getData()];
                    case 1:
                        data = _a.sent();
                        if (data == null)
                            return [2 /*return*/, false
                                //计算绘图数据
                            ];
                        //计算绘图数据
                        this.commondata = (0, commondata_1.countCommonData)(this.options, data);
                        //初始化svg
                        this.container = document.createElement("div");
                        this.container.className = "miniquotechart";
                        this.container.style.width = this.options.width + "px";
                        this.container.style.height = this.options.height + "px";
                        if (type == "update") {
                            this.options.container.replaceChild(this.container, this.options.container.childNodes[0]);
                        }
                        else {
                            this.options.container.appendChild(this.container);
                        }
                        this.svg = new dsvg_1.DSVG(this.container, this.options.width, this.options.height);
                        this.container.style.fontSize = this.options.fontsize + "px";
                        //绘图
                        (0, draw_1.drawTime)(this.svg, data, this.commondata, this.options, this.container);
                        if (this.options.refreshTime && type == 'init') {
                            this.refresh();
                        }
                        return [2 /*return*/, this.svg];
                }
            });
        });
    };
    /**
     * 清除所有DOM、定时器、事件
     */
    Time.prototype.destory = function () {
        this.options.container.innerHTML = "";
        this.timer && clearInterval(this.timer);
    };
    return Time;
}());
exports.Time = Time;
